// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__7mFHn","title":"BackImages_title__3fJvQ","images":"BackImages_images__MlqYZ"};